import {
  Directive, Optional, Self, OnInit, OnDestroy,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { RichTextEditorComponent } from './rich-text-editor.component';
import { Subscription } from 'rxjs';

@Directive({ selector: '[appRichTextEditorValidation]' })
export class RichTextEditorValidationDirective implements OnInit, OnDestroy {
  private subscription = new Subscription();

  constructor(@Optional() @Self() private ngControl: NgControl,
    private richTextEditor: RichTextEditorComponent) {}

  ngOnInit() {
    if (this.ngControl && this.ngControl.control) {
      // Subscribe to control status changes
      this.subscription.add(this.ngControl.control.statusChanges.subscribe(() => {
        this.updateValidationState();
      }));

      // Subscribe to control value changes
      this.subscription.add(this.ngControl.control.valueChanges.subscribe(() => {
        this.updateValidationState();
      }));
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private updateValidationState() {
    if (this.ngControl && this.ngControl.control) {
      this.richTextEditor.currentErrors = this.ngControl.control.errors;
      this.richTextEditor.hasError = this.ngControl.control.invalid && this.ngControl.control.touched;
    }
  }
}
